module.exports = __webpack_public_path__ + "static/media/Tajawal-Regular.6b10b55e.ttf";